import { Stack, Title } from '@mantine/core';
import { BirthdayConfig } from './BirthdayConfig';
import { RevenueThresholdConfig } from './RevenueThresholdConfig';

export function AutomationPage() {
  return (
    <Stack gap="lg">
      <Title order={2}>Automatisierung</Title>
      <BirthdayConfig />
      <RevenueThresholdConfig />
    </Stack>
  );
}
